module.exports = __webpack_public_path__ + "static/media/metrc_logo.4e089d31.png";